<template>
  <div
    class="footer-contact-container"
  >
    <div class="footer-contact" :class="[schema.settings.textColor]">
      <div class="footer-contact__social" v-if="enabledSocial.length > 0">
        <h2
          v-if="schema.settings.socialTitle"
          class="h6 footer-contact__social-title"
          :class="[schema.settings.socialTitleColor]"
        >
          {{ schema.settings.socialTitle }}
        </h2>
        <div class="footer-contact__social-list">
          <a
            class="footer-contact__social-link"
            v-for="social in enabledSocial"
            :key="social.id"
            :href="social.url"
            target="_blank"
            :aria-label="social.id"
          >
            <icon
              class="footer-contact__social-icon"
              :name="social.id"
              :style="iconSize(social.id)"
              :fillClass="schema.settings.socialIconColor"
            ></icon>
          </a>
        </div>
      </div>
    </div>
    <instafeed-controller v-if="schema.settings.instagramFeed==true" />
  </div>
</template>

<script>
import Icon from '@/scripts/components/basic/Icon.vue'
import InstafeedController from '@/scripts/components/basic/InstafeedController.vue';

export default {
  name: 'FooterContactSocial',
  components: {
    Icon,
    InstafeedController,
  },
  props: {
    schema: Object
  },
  methods: {
    iconSize (id) {
      if (id === "instagram") {
        return {
          'max-width': '18px',
          'max-height': '18px',
          'margin-bottom':'10px'
        }
      } else if (id === "facebook") {
        return {
          'max-width': '9px',
          'max-height': '18px',
          'margin-bottom':'10px'
        }
      } else if (id === "youtube") {
        return {
          'max-width': '23px',
          'max-height': '16px',
          'margin-bottom':'10px'
        }
      }else if (id === "tiktok") {
        return {
          'max-width': '18px',
          'max-height': '18px',
          'margin-bottom':'10px'
        }
      }
       else {
        return {
          'max-width': '18px',
          'max-height': '18px'
        }
      }
    },
  },
  data () {
    return {}
  },
  computed: {
    enabledSocial () {
      return this.schema.settings.socialLinks.filter(
        social => social.id !== 'none'
      )
    },
  }
}
</script>

<style lang="scss">
.footer-contact-container {
  padding: 0 0 12px;
  margin-bottom: 0px;

  @include tablet-only {
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin-left: 32px;
  }

  @include tablet-up {
    flex: 1;
    padding: 32px 0 12px 16px;
    margin-bottom: 140px;
  }

  @include desktop-up {
    max-width: 1243px;
    margin: 0 auto 0px;
  }
}

.footer-contact {
  display: flex;
  margin: 0 auto;
  flex-wrap: wrap;
  overflow: hidden;
  
  @include mobile-only {
    margin-bottom: rem(16);
  }

  @include tablet-only {
    margin-left: 0;
  }

  @include tablet-up {
    flex-wrap: nowrap;
    flex-shrink: 0;
    justify-content: center;
    margin-right: rem(30);
    margin-bottom: rem(30);
  }

  &__contact,
  &__social {
    flex-basis: 50%;
    flex-grow: 1;
    order: 1;

    @include tablet-up {
      flex-basis: auto;
    }

    &:nth-child(1) {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }

    .footer-content--center & {
      @include mobile-only {
        text-align: center;
      }
    }
  }

  &__contact {
    margin-bottom: 16px;
    padding-right: 4px;

    @include tablet-up {
      min-width: 200px;
      margin: 0 16px;
      padding-right: 0;
      flex-grow: 0;
    }

    @include desktop-up {
      margin: 0 20px 16px;      
    }

    &:nth-child(2) {
      order: 2;

      @include tablet-up {
        order: 1;
      }

      .footer-content--center & {
        @include mobile-only {
          order: 1;
        }
      }
    }
  }

  &__social {
    padding-left: 4px;
    text-align: center;

    @include tablet-up {
      text-align: left;
    }
  }

  &__contact-title,
  &__social-title {
    margin-bottom: 12px;

    @include tablet-up {
      margin-bottom: 28px;
    }
  }

  &__social-title {
    @include mobile-only {
      position: absolute;
      bottom: 56px;
      left: 50%;
      transform: translateX(-50%);
    }

    &.color-white {
      color: $color-white;
    }
  }

  &__contact-body {
    p,
    span,
    em,
    strong,
    a {
      font-size: inherit;
      line-height: inherit;
    }

    p:empty {
      margin: 4px 0;
    }
  }

  &__social-link {
    display: inline-block;
    margin-top: 4px;
    margin-bottom: 4px;
    &:not(:last-child) {
      margin-right: 15px;
    }
    @include tablet-up {
      margin-top: 8px;
      margin-bottom: 8px;
    }
  }
}
</style>
